// Site-wide footer. Lives below the routed page content so legal and
// support links are reachable from every page (including the public
// landing page that Google crawls).

import React from "react";
import { Link } from "react-router-dom";
import * as Urls from "../fleet-shared/Urls.mjs";
import { PRODUCT_NAME } from "../fleet-shared/Brand.mjs";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="py-3 mt-4 border-top bg-body-tertiary">
      <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">
        <p className="m-0 text-body-secondary small">
          &copy; {year} {PRODUCT_NAME}
        </p>
        <nav aria-label="Footer">
          <ul className="list-inline m-0 small">
            <li className="list-inline-item">
              <Link to={Urls.urlForPrivacy()} className="text-body-secondary">
                Privacy
              </Link>
            </li>
            <li className="list-inline-item mx-2 text-body-secondary" aria-hidden="true">
              &middot;
            </li>
            <li className="list-inline-item">
              <Link to={Urls.urlForTerms()} className="text-body-secondary">
                Terms
              </Link>
            </li>
            <li className="list-inline-item mx-2 text-body-secondary" aria-hidden="true">
              &middot;
            </li>
            <li className="list-inline-item">
              <Link to={Urls.urlForSupport()} className="text-body-secondary">
                Support
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
